import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Client } from '@/api/profile';
import { profileAbb, profileColor } from '@/api/graphicIdentifier';
import updateData from '@/api/updateData';

@Component({
})
export default class ClientListElementAbstract extends Vue {
    @Prop() client!: Client
    get profileAbb() {
        return profileAbb(this.client.fio)
    }
    get profileColor() {
        return profileColor(this.client.fio)
    }
    toProfile() {
        this.$router.push({
            name: 'myClient',
            params: {
                cid: this.client.c1code,
                client: JSON.stringify(updateData(new Client(), this.client))
            }
        })
    }
    async setProfileAndToBasket() {
        this.$store.dispatch('setManagerClientProfile', this.client)
        this.$router.push('/basket')
    }
    textOtgr(otgr: number)  {
        switch (+otgr) {
            case -1:
                return 'ЦенаОт0До3'
            case 0:
                return 'ЦенаОт0До3'
            case 1:
                return 'ЦенаОт0До3'
            case 2:
                return 'ЦенаОт4До14'
            case 3:
                return 'ЦенаОт15До366'
            default:
                return '-'
        }
    }
}